import { render, staticRenderFns } from "./Garch.vue?vue&type=template&id=1108f3b1&scoped=true&"
import script from "./Garch.vue?vue&type=script&lang=js&"
export * from "./Garch.vue?vue&type=script&lang=js&"
import style0 from "./Garch.vue?vue&type=style&index=0&id=1108f3b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1108f3b1",
  null
  
)

export default component.exports